import { render } from "./ServiceCenter.vue?vue&type=template&id=52a412b6"
import script from "./ServiceCenter.vue?vue&type=script&lang=js"
export * from "./ServiceCenter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__